<script setup>
import CopyButton from "../../lib/components/CopyButton.vue";

defineProps(["setup"]);
defineEmits(["confirm"]);

const iOS = /iPhone|iPad/.test(navigator.userAgent);
</script>

<template>
	<UiDialog style="width: 700px" modal>
		<h1>Laderoppsett</h1>
		<p>Før du kan tilby lading via ZEV, må laderinstallasjonen din kobles til ZEV via Open Charge Point Protocol (OCPP). Bruk følgende innstilinger på din ladeinstallasjon.</p>
		<label for="url">OCPP URL</label>
		<div style="display: flex; gap: 0.5em; margin-bottom: 0.25em">
			<input id="url" :value="setup.url" type="text" readonly>
			<CopyButton v-if="!iOS" :value="setup.url"/>
		</div>
		<label for="passwd">OCPP passord</label>
		<div style="display: flex; gap: 0.5em; margin-bottom: 0.25em">
			<input id="passwd" :value="setup.passwd" type="text" readonly>
			<CopyButton v-if="!iOS" :value="setup.passwd"/>
		</div>
		<h3>Veiledning for Zaptec ladestasjoner:</h3>
		<ol>
			<li>Gå til <a href="https://portal.zaptec.com" target="_blank">Zaptec portal</a> og logg inn</li>
			<li>Naviger til Ladestasjoner i øverste hovedmeny</li>
			<li>Velg aktuell Installasjon i listen</li>
			<li>Gå til fanen Innstillinger og videre til Autentisering</li>
			<li>Velg OCPP 1.6J sky-autentisering</li>
			<li>
				Legg inn følgende verdier:
				<ul>
					<li>URL: kopier OCPP URL over</li>
					<li>Standard ladestasjonspassord: kopier OCPP passord over</li>
					<li>Default ID-tag: tom</li>
					<li>Autorisering påkrevd: på</li>
					<li>Bruk eldre OCPP-metode: av</li>
					<li>Deaktiver autorisering når ladestasjoner er uten nett: av</li>
				</ul>
			</li>
			<li>Lagre endringene</li>
			<li>
				Gå til Ladestasjoner i øverste hovedmeny og for hver enkelt ladestasjon i listen, gjør følgende:
				<ol>
					<li>Gå inn på ladestasjonen</li>
					<li>Sjekk at "Autorisering påkrevd" er slått på. Dersom dette ikke er tilfelle, slå på og trykk "Lagre".</li>
				</ol>
			</li>
			<li>Merk: dersom installasjonen er koblet til Tibber eller tilsvarende tjenester for strøm- eller ladeoptimalisering, må dette slås av for å unngå at lading potensielt hindres. Dersom du har en bil som støtter det kan du få smartlading ved å flytte den smarte delen fra <a href="/tibber" target="_blank">ladeboksen til bilen</a>.</li>
		</ol>
		<p>Når dette er utført, vil laderene koble seg til ZEV i løpet av kort tid.</p>
		<div class="btn-row right" style="margin-top: 2em">
			<button class="ui" @click="$emit('confirm')">OK</button>
		</div>
	</UiDialog>
</template>
